<template>
  <!-- 分页器 -->
  <div class="paging_box">
    <span class="total">共{{ total }}条</span>
    <span class="perPage_num">本页{{ list.length }}条</span>
    <el-pagination
      layout="prev, pager, next"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      @current-change="changePage"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    // 总数
    total: {
      type: Number,
      default: 0
    },
    // 列表显示的总数
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    // 当前页数
    page: {
      type: Number,
      default: 1
    },
    // 每页条数
    pageSize: {
      type: Number,
      default: 10
    }
  },
  methods: {
    // 点击翻页
    changePage(e) {
      this.$emit("change", e);
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/index/components/Pagination.vue